export default __webpack_public_path__ + "static/media/app_example_3.1aee0852.png";